import React, {useState, useEffect} from 'react';

import {Card, Table, Container, Alert, ProgressBar, Badge} from 'react-bootstrap';

import axios from 'axios';
import FileDownload from 'js-file-download';
import moment from 'moment';
import { MessageModal } from '../components';
import Utils from './../Utils';

const UserScormList = (props) => {
  
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({offset: 0, limit: 10, sortby: "id", sortdir: "desc"});  
  const [data ,setData] = useState([]);
  const [total ,setTotal] = useState(0);
  const [message, setMessage] = useState(false);
  
  const fetchScorms = () => {

    setLoading('Fetching your saved scorms.. please wait..');

    axios.post(Utils.apiUrl('Scorm/list'),{...filter},Utils.apiHeaders()).then(res => {    
      setLoading(false);
      // if(res.data.data === false){        
      //   Utils.removeSession();
      //   window.location.href = process.env.PUBLIC_URL + '/login';
      //   return;
      // }   
      setData(res.data.data);
      setTotal(res.data.total);
      let udata = Utils.getUserData();
      udata[`stepData${udata.id}`] = {step : 1};
      localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData',JSON.stringify(udata));
    }).catch(err => {      
      window.alert(JSON.stringify(err)); 
    });        
  }

  useEffect(fetchScorms,[filter]);

  const onClone = (rid,isweb) => (e) => {
    Utils.setCourseType('clone');

    setLoading('Cloning your scorm.. please wait..');
    var api = '';
    if(isweb === '1'){
      api = Utils.apiUrl('Web/clone');
    }else{
      api = Utils.apiUrl('Scorm/clone');
    }
    axios.post(api,{id: rid},Utils.apiHeaders()).then(res => {
      if(res.data.success){
        let udata = Utils.getUserData();
        udata[`stepData${udata.id}`]['scorm_id'] = res.data.newid;
        localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData',JSON.stringify(udata));
        window.location.href= process.env.PUBLIC_URL + '/builder/' + res.data.newid + '/' + isweb;
      }else{
        window.alert(res.data.error);
      }
    }).catch(err => {
      window.alert(JSON.stringify(err)); 
    });  
  }

  const onDownload = (rid,folder,isweb) => (e) => {
    var headers = {...Utils.apiHeaders(), "responseType": "blob"};
    setMessage(['info', ['Please wait, We are processing your file...']]);
    setMessage(['info', ['Please wait, We are processing your file']]);
    var api = '';
    if(isweb === '1'){
      api = Utils.apiUrl('Web/download?id=' + rid);
    }else{
      api = Utils.apiUrl('Scorm/download?id=' + rid);
    }
    axios.get(api,headers).then((res) => {      
      FileDownload(res.data, folder+'.zip');
      setMessage(false);
      fetchScorms();
    });
  }

  const onSort = (ck) => (e) => {
    const tmp = {...filter};
    if(tmp.sortby===ck){
      tmp.sortdir = tmp.sortdir === 'asc' ? 'desc' : 'asc';
    }else{
      tmp.sortby=ck;
      tmp.sortdir='desc';
    }
    setFilter({...tmp});
  }

  const actionIcon = (e) => {
    
  }
  
  const renderListing = () => {
    const cols = {
      'id': 'Sl.',
      'name': 'Name',
      'slides': 'Slides',
      'created_at': 'Created On',
      'publishes': 'Downloads',
      //'is_web': 'Type',
      // 'downloads': 'Downloads', //commented as per new logic discussed with Surojit sir.
    };
    return <>
    {renderPaging()}
    <Table striped>
      <tr>
        {Object.keys(cols).map(ck => <th key={ck} className={`text-${ck==='id' || ck==='name' ? 'left' : 'center'}`}>
          <span className="clickable text-info" onClick={onSort(ck)}>{cols[ck]}</span> 
          {filter.sortby===ck && <i className={`ml-1 sort-arrow fa fa-arrow-${filter.sortdir==='asc' ? 'up' : 'down'} text-dark`} />}
        </th>)}
        <th className="text-center">Action</th>
      </tr>
      {data.map((rec,idx) => <tr key={rec.id}>
        <td>{filter.offset + idx + 1}</td>
        <td>{rec.name}</td>        
        <td className="text-center">{rec.slides}</td>
        <td className="text-center">{moment(rec.created_at).format("DD MMM YYYY hh:mm a")}</td>
        <td className="text-center"><Badge variant="dark">{rec.publishes}</Badge></td>
        {/* <td className="text-center">{rec.is_web == true ? 'WEB' : 'SCORM'}</td> */}
        <td className="text-center actions"> 
          <a href={`${process.env.PUBLIC_URL}/builder/${rec.id}/${rec.is_web}`}><span className="edit clickable" onMouseOver={(e) => {actionIcon(e)}} title="Edit Package" /></a>
          <span className="clone clickable" title="Clone and Edit this Package" onClick={onClone(rec.id,rec.is_web)} />
          <span className="download clickable" title="Download Package" onClick={onDownload(rec.id,rec.name,rec.is_web)} />
        </td>
      </tr>)}
    </Table>
    {renderPaging()}
    </>
  }

  const renderPaging = () => {
    return <div className="text-right pager">
      {filter.offset - filter.limit >= 0 && <span className="fa fa-chevron-left mx-2 clickable" title="Previous page" onClick={() => setFilter({...filter, offset: filter.offset-filter.limit})} />}
      {filter.offset - filter.limit < 0 && <span className="fa fa-chevron-left text-disabled" />}
      {filter.offset + filter.limit < total && <span className="fa fa-chevron-right mx-2 clickable" title="Next page" onClick={() => setFilter({...filter, offset: filter.offset+filter.limit})} />}
      {filter.offset + filter.limit > total && <span className="fa fa-chevron-right text-disabled" />}
    </div>
  }

  return <Container className="scromlist">
    <div className="mb-3"><span className="clickable" onClick={() => {window.location.href=`${process.env.PUBLIC_URL}/Builder`;}}><img src={`${process.env.PUBLIC_URL}/images/back_arrow.png`} alt="Back" /> Back</span></div>

    <div className="heading mb-4"><span>My SCORM Packages</span> <a href={process.env.PUBLIC_URL + '/builder'} title="Build a SCORM"><i className="fa fa-plus" /></a></div>

    <Card className="card-box w-100">
      <Card.Body className="p-4">        
               
        <ol className="instructions">
          <li><span>Course can be modified by clicking <i className="edit"></i> <strong>Edit Package.</strong></span> </li>
          <li><span>Click on <i className="clone"></i>  to <strong>Clone and Edit this Package</strong>. </span> </li>
          <li><span>You can </span> <i className="download"></i> <strong>  Download Package.</strong></li>
        </ol>

        {loading && <div className="text-center p-2 m-2"><Alert> {loading}<br /><ProgressBar className="mt-2" animated variant="primary" now={100} /></Alert></div>}
        {!loading && total > 0 && renderListing()}
        {!loading && total === 0 && <div className="text-center p-2 m-2"><Alert variant="warning">No Records found</Alert></div>}

        
        {message && <MessageModal type={message[0]} dwn={true} message={message[1]} onHide={() => {setMessage(false);}} />} 

      </Card.Body>
    </Card>
  </Container>;
}

export default UserScormList;